import type { Markings } from 'chessboard/plugins/markings/config/types';
import type JCE from '@chesscom/js-chess-engine';
import { getMarkingsFromJCE } from 'plugins/markings/model/get-markings-from-jce';
import { getNodeIdsFromMarking } from '../service';

/**
 * Check if a node has a specific marking.
 */
export function JCENodeHasMarking(
  game: JCE.Game,
  marking: Markings.KeyedModel,
  { onlyCurrentNode }: { onlyCurrentNode?: boolean } = {},
): boolean {
  const { key } = marking;
  const initialPos = game.ids();
  const markingNodeIds = getNodeIdsFromMarking(marking);

  if (!markingNodeIds) {
    return false;
  }

  const { move, line } = markingNodeIds;

  const alternateNode = initialPos.move !== move || initialPos.line !== line;

  if (alternateNode) {
    if (onlyCurrentNode) {
      return false;
    }
    game.selectPosition(move, line);
  }

  const jceMarkings = getMarkingsFromJCE(game);

  if (alternateNode) {
    game.selectPosition(initialPos.move, initialPos.line);
  }

  return Boolean(jceMarkings.find((item) => item.key === key));
}
